/**
 * Footer Menu
 * PC：常に展開
 * SP：アコーディオン
 */

(function () {

  function initFooterMenu() {

    const details = document.querySelectorAll('.footer-menu details');

    if (!details.length) return;

    if (window.innerWidth >= 768) {

      details.forEach(detail => {
        detail.open = true;
      });

    } else {

      details.forEach(detail => {
        detail.open = false;
      });

    }

  }

  document.addEventListener('DOMContentLoaded', initFooterMenu);

  document.addEventListener('shopify:section:load', initFooterMenu);

  window.addEventListener('resize', initFooterMenu);

})();